module.exports = __webpack_public_path__ + "components/flag/static/square/bh-15b3c2f787e4c7a1d57ff5f80dcf71f7.svg";